module.exports = __webpack_public_path__ + "a03d8b05.svg";